import { Buffer } from "buffer";
import FormStore from "../../Configs/Store/forms.js";
import AppStore from "../../Configs/Store/index.js";
import { leadWSAPI } from "../../Configs/API";
import service from "@ipru-common/services/service";
import { ApiName } from "@ipru-common/services/ApiEndpoints.js";

const Blowfish = require("egoroof-blowfish");

const BF_KEY = ["!t@a6@($%(", "DIGI1234", "Mt%sOmD17r-pqZN", "!i@*6@($%("];
const BF_MODE = Blowfish.MODE.EBC;
const BF_PADDING = Blowfish.PADDING.PKCS5;
const BF_TYPE = Blowfish.TYPE.STRING;

const BF_OG = new Blowfish(BF_KEY[0], BF_MODE, BF_PADDING);
const BF_DG = new Blowfish(BF_KEY[1], BF_MODE, BF_PADDING);
const BF_DEP = new Blowfish(BF_KEY[2], BF_MODE, BF_PADDING);
const BF_GRPEMP = new Blowfish(BF_KEY[3], BF_MODE, BF_PADDING);
export const NDNC_DISCLAIMER_FULL =
  "By submitting my details, I override my NCPR registration and authorize ICICI Life Insurance Company Limited, its third parties and its representatives to contact me through call, RCS, WhatsApp, E-Mail or other modes. I further consent to permit ICICI Life Insurance Company Limited to process and share my information with its third parties and its representatives for (i) contacting me (ii) evaluating and processing this proposal (iii) risk assessment (iv) conducting surveys and feedback in relation to the Company’s services/ offerings (v) enhancing its products/ services and undertaking research and analysis.";
export const NDNC_DISCLAIMER_TRUNCATED =
  "By submitting my details, I override my NCPR registration and authorize ICICI Life Insurance Company Limited, its third parties and its representatives to contact me through call, RCS, WhatsApp, E-Mail or other modes. I further consent to permit ICICI Life Insurance Company Limited to process and share my information with its third parties and its representatives for (i) contacting me (ii) evaluating and processing this proposal (iii) risk assessment";

var lastExtRequest = null;

const BlowFishReact = (encrypt, key, data) => {
  var BF =
    key === "DIGI"
      ? BF_DG
      : key === "DEP"
        ? BF_DEP
        : key === "GRPEMP"
          ? BF_GRPEMP
          : BF_OG;
  if (encrypt) {
    var encryptedData = BF.encode(
      key === "GRPEMP" ? data : JSON.stringify(data),
    );
    encryptedData = Buffer.from(encryptedData).toString("base64");
    return encryptedData;
  } else {
    var dataBuffered = Buffer.from(data, "base64");
    var decryptedData = BF.decode(dataBuffered, BF_TYPE);
    return decryptedData;
  }
};

const numDifferentiation = (val, point) => {
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(point);
    val = parseFloat(val) + " Crore";
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(point);
    val = parseFloat(val) + " Lakh";
  } else {
    val = parseFloat(val).toFixed(0);
    val = (val + "").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  }
  return val;
};

window.BlowFishReact = BlowFishReact;

var UserDataJSON = window.UserDataJSON;
var clientId = window.clientId;
var UserInput = window.UserInput;
var PrefillUserJson = window.PrefillUserJson || {};

var fillLead_flag = window.fillLead_flag;
var gamoogaEvent = window.gamoogaEvent;
var Enc_UserData = window.Enc_UserData;
// var isDate = window.isDate;
function isDate(txtDate) {
  var currVal = txtDate;
  if (currVal == "" || currVal == undefined) {
    return false;
  } else {
    //bool = false;
    var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; //Declare Regex
    var dtArray = currVal.match(rxDatePattern); // is format OK?
  }
  if (dtArray == null) return false;
  //Checks for dd/mm/yyyy format.
  var dtMonth = dtArray[3];
  var dtDay = dtArray[1];
  var dtYear = dtArray[5];
  if (dtMonth < 1 || dtMonth > 12) return false;
  else if (dtDay < 1 || dtDay > 31) return false;
  else if (
    (dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) &&
    dtDay == 31
  )
    return false;
  else if (dtMonth == 2) {
    var isleap = dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0);
    if (dtDay > 29 || (dtDay == 29 && !isleap)) return false;
  }
  return true;
}

var Glb_UID = window.Glb_UID;

async function CreateReactCookie() {
  var UserInput = window.UserInput;
  var cookieTS = new Date().getTime();
  try {
    for (var key in UserInput) {
      if (UserInput[key] != undefined) {
        PrefillUserJson[key] = UserInput[key].toString();
      }
    }

    if (isDate(UserInput.dob)) {
      var d = new Date();
      d.setTime(d.getTime() + 91 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var UserDataJSON = (Enc_UserData = "");
      var birthdateorig = UserInput.dob.split("/");
      var currentyear = new Date().getFullYear();
      var date2 = new Date();
      var finaldob = new Date(
        birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear,
      );
      var finaldob = new Date(
        birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear,
      );
      var timeDiff = finaldob.getTime() - date2.getTime();
      var daysdiff = Math.ceil(timeDiff / (1000 * 24 * 3600));
      try {
        PrefillUserJson.GAid = document.cookie
          .split("GA_VisitorID=")[1]
          .split(";")[0];
      } catch {
        PrefillUserJson.GAid = "";
      }
      PrefillUserJson.PageName = "Retirement Plan GPP Calculator";
      PrefillUserJson.UID = Glb_UID;
      PrefillUserJson.timestamp = cookieTS;
      // PrefillUserJson.lifeCover2 = setValFW(PrefillUserJson.lifeCover);

      // Enc_UserData = JSON.stringify(PrefillUserJson)

      var UserDataJSON = await BlowFishReact(true, "", PrefillUserJson);
      // var UserDataJSON2 = await BlowFishReact(false, "", UserDataJSON)

      // console.log("cookie GPPTimeStamp", PrefillUserJson)
 
      localStorage.setItem("GPPCookie", UserDataJSON);
      if (date2.getMonth() == 10 || date2.getMonth() == 11) {
        if (finaldob.getMonth() >= date2.getMonth()) {
        } else {
          currentyear = currentyear + 1;
          finaldob = new Date(
            birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear,
          );
        }
      }
      if (daysdiff > 0 && daysdiff <= 60) {
        localStorage.setItem("BirthdayUsecase", "true");
      } else {
        localStorage.setItem("BirthdayUsecase", "false");
      }
    }
  } catch (e) {
    console.log("Error: CreateCookie Function - " + e);
  }

  var UserDataJSON1 =
    "GPPproductId=I13&dob=" +
    UserInput.dob +
    "&timestamp=" +
    cookieTS +
    "&ends=" +
    this;
  UserDataJSON1 = await BlowFishReact(true, "", UserDataJSON1);
  // console.info("UserDataJSON1 :", UserDataJSON1)
  localStorage.setItem("encryptedCookie", UserDataJSON1);
  if (typeof setStorageBoi == "function") {
    var commonInfo = { ...UserInput };
    commonInfo.highProductCategory = "Savings";
    setStorageBoi(UserInput, "productInfoGPP");
    setStorageBoi(commonInfo, "productInfoCommon");
  }

  try {
    if (UserInput.TRAI_FLAG == "YES") {
      window.GamoogaDataFlow();
    }
  } catch (e) {
    console.log("Error: CreateCookie Gamooga - " + e);
  }
}

window.CreateReactCookie = CreateReactCookie;

const addCommas = (nStr) => {
  return nStr.toString().replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,");
};

const removeCommas = (numWidCommas) => {
  return numWidCommas.replace(/[,]/g, "");
};

const downloadFile = (url, fileName) => {
  var element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("target", "_blank");
  element.setAttribute("download", fileName);
  element.setAttribute("type", "application/pdf");
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
const numConvert = (n) => {
  let ord = ["st", "nd", "rd"];
  let exceptions = [11, 12, 13];
  let nth =
    ord[(n % 10) - 1] === undefined || exceptions.includes(n % 100)
      ? "th"
      : ord[(n % 10) - 1];
  return n + nth;
};

const scrollToClass = (target) => {
  var element = document.getElementsByClassName(target)[0];
  element.scrollIntoView({ behavior: "smooth", block: "center" });
};

const scrollToId = (target) => {
  var element = document.getElementById(target);
  element.scrollIntoView({ behavior: "smooth", block: "center" });
};

const getCookieBoi = async (cname) => {
  try {
    var name = cname + "=";
    // var data = document.cookie.split("encryptedCookie=")
    var data = localStorage.getItem("encryptedCookie")
    var UserDataJSON = await BlowFishReact(false, "", data);
    UserDataJSON = UserDataJSON.replace('"', "");
    UserDataJSON = UserDataJSON.split("&ends")[0];
    var ca = UserDataJSON.split("&");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        var temp = c.substring(name.length, c.length);
        return temp;
      }
    }
    return "";
  } catch (err) {
    // console.info("CA Debug 3 No Enc Cookie", err)
  }
};

const getReactCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const getStorageBoi = async (key, count = 0) => {
  count = count + 1;
  if (count > 5) {
    return false;
  }
  try {
    var value = await JSON.parse(
      window.$.jCryptionDIGI.decrypt(localStorage.getItem(key), "encrypt"),
    );
    console.info("getStorageBoi Value :", window.UserInput.dob, value.dob);
    if (window.UserInput.dob === value.dob) {
      console.log("value matched");
      window.localDobFlag = true;
      return value;
    }
  } catch (e) {
    console.log(
      "getStorageBoi: Error reading key [" +
        key +
        "] from localStorage: " +
        JSON.stringify(e),
    );
    return new Promise((res) =>
      setTimeout(() => res(getStorageBoi(key, count)), 1000),
    );
  }
};

const getReactStorageBoi = async (key) => {
  // Prodigy Funtion
  try {
    var tempStorage = localStorage.getItem(key + "_R");
    var SyncDOB = await BlowFishReact(false, "DEP", tempStorage);
    return JSON.parse(SyncDOB);
  } catch {
    return false;
  }
};

const setStorageBoi = async (data, key, count = 0) => {
  console.info("Set Storage :", data);
  count = count + 1;
  if (count > 5) {
    return false;
  }
  if (count === 1) {
    var SyncDOB = await BlowFishReact(true, "DEP", data);
    localStorage.setItem(key + "_R", SyncDOB);
  }
  try {
    var dataStr = JSON.stringify(data);
    var encryptedData = window.$.jCryptionDIGI.encrypt(dataStr, "encrypt");
    localStorage.setItem(key, encryptedData);
    console.info("setStorageBoi Passed :", data, key, count);
  } catch (e) {
    console.log(
      "setStorageBoi: Error setting key [" +
        key +
        "] in localStorage: " +
        JSON.stringify(e),
    );
    return new Promise((res) =>
      setTimeout(() => res(setStorageBoi(data, key, count)), 1000),
    );
  }
  return true;
};

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const capitalize = (str) => {
  try {
    return str[0].toUpperCase() + str.slice(1);
  } catch {
    return str;
  }
};

const scrollPatch = (type) => {
  setTimeout(() => {
    try {
      var contentWrapper = document.getElementsByTagName("body")[0];
      if (contentWrapper.hasAttribute("style")) {
        contentWrapper.style.overflow = type;
      }
    } catch {}
  }, 1000);
};
const validateName = (value) => {
  return value.length > 0;
};

const validatePhone = (value) => {
  return value === "" || value.toString().length === 10;
};

const validateEmail = (value) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(value);
};
const ToggleCheckboxError = (formRef, formName, validationFlag, temp) => {
  console.info(
    "FormName",
    formName,
    "formRef",
    formRef,
    "validationFlag",
    validationFlag,
  );
  var element = document
    .querySelector(`#${formName}`)
    .closest(".CheckboxGroup").classList;

  formRef.setFields([{ name: formName, errors: validationFlag ? [" "] : [] }]);

  if (validationFlag) {
    if (!element.contains("ErrorExist")) {
      element.add("ErrorExist");
    }
  } else {
    if (element.contains("ErrorExist")) {
      element.remove("ErrorExist");
    }
  }
};

//Masking Common Function
const mask = (value) => {
  const data = value.split("");
  var len = data.length;
  var newarr = [];
  for (var i = 0; i <= len - 1; i++) {
    if (i == 0 || i == 1 || i == len - 1) {
      newarr[i] = data[i];
    } else {
      newarr[i] = "X";
    }
  }
  const response = newarr.toString().replace(/,/g, "");
  return response;
};

const maskData = (value) => {
  const dob = value.split("/");
  const data =
    dob[0] +
    "/XX" +
    "/XXX" +
    dob[2].substring(dob[2].length - 1, dob[2].length);
  return data;
};

const maskMobile = (value) => {
  const mob = value.toString().split("");
  const maskedmob = mob[0] + mob[1] + "XXXXXXX" + mob[9];
  return maskedmob;
};

const maskEmail = (value) => {
  const mail = value.split("@");
  const provider = mail[1].split(".");
  const name = mask(mail[0]);
  const mailprovider0 = mask(provider[0]);
  const mailprovider1 = mask(provider[1]);
  console.log(name, "@", provider);
  const maskedMail = name + "@" + mailprovider0 + "." + mailprovider1;
  return maskedMail.toLowerCase();
};

const HideLandingLoader = () => {
  document.querySelector(".Spinner_Background").style.display = "none";
  var spinner = document.querySelector("body").classList;
  if (spinner.contains("Spinner_Default")) spinner.remove("Spinner_Default");
};

const InjectCustomAppForm = () => {
  var randomTS = new Date().getTime();
  var s = document.createElement("script");
  if (
    window.location.hostname ===
      "depronto-ipru-projects.s3.ap-south-1.amazonaws.com" &&
    AppStore.depTesting
  ) {
    s.src =
      "https://depronto-ipru-projects.s3.ap-south-1.amazonaws.com/content/icici-prudential-life-insurance/testing/Lokesh/custAppForm/expBuy_UR/js/custom-application-form.min.js?v=" +
      randomTS; // Local
  } else if (
    window.location.href.includes("localhost") ||
    window.location.href.includes("127.0.0.1")
  ) {
    s.src =
      "http://127.0.0.1:5502/custAppForm/expBuy_UR/js/custom-application-form.min.js?v=" +
      randomTS; // Local
  } else if (window.location.href.includes("testing")) {
    s.src = process.env.REACT_APP_APPFORM_UAT + randomTS;
  } else {
    s.src = process.env.REACT_APP_APPFORM_PROD + randomTS;
  }
  document.body.appendChild(s);
};

const suitablityUserInput = (key, subKey, value) => {
  if (subKey !== "") {
    window.suitablity_UserInput[key][subKey] = value;
  } else {
    window.suitablity_UserInput[key] = value;
  }
};

const ExistingCustToaster = async () => {
  return new Promise(async (resolve, reject) => {
    var datyArr = FormStore?.calc_dob?.split("/");
    var day = datyArr?.[0];
    var month = datyArr?.[1];
    var year = datyArr?.[2];

    var request = {
      input: FormStore?.calc_phone, // "9092153521",
      inputLevel: "2",
      DOB: year + month + day, // "19850307"
    };

    var curExtRequest = request.input + request.DOB;

    if (curExtRequest !== lastExtRequest) {
      lastExtRequest = curExtRequest;
      let extCustResponse;
      try {
        extCustResponse = await window.callMiddlewareAPI(
          ApiName.EXTCUSTAPI,
          request,
        );
      } catch (e) {
        console.log("ExtcustApi error", e);
      }

      window.existingCustDetails = extCustResponse;
      if (extCustResponse) {
        FormStore.setExistingCustDetails(extCustResponse);
        // extCustResponse = extCustResponse.ResponseElement[0];
        if (extCustResponse.CLIENT_NAME && extCustResponse.CLIENT_NAME != "") {
          window.UserInput.youth_express = "ExistCust_Yes";
          window.UserInput.fName = extCustResponse.CLIENT_NAME;
        } else {
          window.UserInput.youth_express = "ExistCust_No";
        }
        extCustResponse = window.extCustResponse;
        resolve(true);
        return extCustResponse;
      } else {
        window.UserInput.youth_express = "ExistCust_No";
        console.log("Failed" + extCustResponse);
        resolve(false);
        return false;
      }
    } else resolve(false);
  });
};

const ExistingCustomer = async () => {
  try {
    await ExistingCustToaster();
  } catch (e) {
    console.warn("showExistingCustToaster failed", e);
  }
  try {
    await leadWSAPI(FormStore);
  } catch (e) {
    console.warn("leadWSAPI failed", e);
  }
};

const AppFormFunctions = (flag) => {
  var isResume = flag === 1;
  console.warn("Looping Ropes...");
  // console.warn("areDependencyLoaded :", isResume, window.UserDataJSON, window.PopulateAppForm, window.Messageorder_cust, window.configFieldsInfo)
  if (
    typeof window.UserDataJSON === "object" &&
    typeof window.PopulateAppForm === "function" &&
    typeof window.Messageorder_cust === "object" &&
    typeof window.configFieldsInfo === "object" &&
    typeof window.Service_OCR === "function"
  ) {
    return true;
  } else {
    return false;
  }
};
const GrabToHScroll = (target) => {
  const slider = document.querySelector(`.${target}`);
  let mouseDown = false;
  let startX, scrollLeft;
  let startDragging = function (e) {
    mouseDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };
  let stopDragging = function (event) {
    mouseDown = false;
    if (slider.classList.contains("Grabbing"))
      slider.classList.remove("Grabbing");
    slider.classList.add("Grab");
  };

  slider.addEventListener("mousemove", (e) => {
    e.preventDefault();
    if (!mouseDown) {
      return;
    }
    if (slider.classList.contains("Grab")) slider.classList.remove("Grab");
    slider.classList.add("Grabbing");
    const x = e.pageX - slider.offsetLeft;
    const scroll = x - startX;
    slider.scrollLeft = scrollLeft - scroll;
  });

  slider.addEventListener("mousedown", startDragging, false);
  slider.addEventListener("mouseup", stopDragging, false);
  slider.addEventListener("mouseleave", stopDragging, false);
};

//Middleware For CKYC
window.UserSession = {
  SessionToken: "",
  JwtToken: "",
};
async function generateJWTToken(iSUat, isMiddleware = false) {
  try {
    const headers = new Headers();
    // const authValue = iSUat ? "RFFGdVBCV3BpdXRjQmlmb3R2aXl5bVFIaVM3RXAyM1Q6bURYa05iOXd3ZmZQVGNGTQ==" : isMiddleware ? "bkdLUHNpWklCdU9LbWhvODFzTE1BY2Vva3EzbUJRVks6enBaUnZSd3h5ekR4NUc4aw==" : "aWlqVW5HVWZWYlNLOUtWVHNxVFltUE1IeEZZWnQ2aFQ6RVBLelZaTm5JU2tXN2ZlMQ=="

    // const authValue = iSUat
    // ? (isMiddleware
    //     ? "Basic S2ZUZkdqSEdURHBkUkE4RXRHS0NiWlpBalNyQ3U5S1Q6RXI1WHFkeEFneFgyQ1lGVA"
    //     : "Basic RFFGdVBCV3BpdXRjQmlmb3R2aXl5bVFIaVM3RXAyM1Q6bURYa05iOXd3ZmZQVGNGTQ==")
    // : (isMiddleware
    //     ? "bkdLUHNpWklCdU9LbWhvODFzTE1BY2Vva3EzbUJRVks6enBaUnZSd3h5ekR4NUc4aw=="
    //     : "aWlqVW5HVWZWYlNLOUtWVHNxVFltUE1IeEZZWnQ2aFQ6RVBLelZaTm5JU2tXN2ZlMQ==")

    let authValue;
    if (iSUat) {
      authValue = process.env.REACT_APP_JWT_UAT_KEY;
      if (isMiddleware) {
        authValue = process.env.REACT_APP_JWT_UAT_MIDDLEWARE_KEY;
      }
    } else {
      authValue = process.env.REACT_APP_JWT_PROD_KEY;
      if (isMiddleware) {
        authValue = process.env.REACT_APP_JWT_PROD_MIDDLEWARE_KEY;
      }
    }
    headers.append("Authorization", `Basic ${authValue}`);
    var payloadOption = {
      method: "POST",
      credentials: "include",
      headers: headers,
    };
    const jwtReq = iSUat
      ? await fetch(
          "https://api-dex.icicilife.com/v1/oauth/jwt",
          payloadOption,
        )
      : await fetch("https://api.icicilife.com/v1/oauth/jwt", payloadOption);
    const jwtRes = await jwtReq.json();
    // console.log(jwtRes)
    const token = jwtRes.token;
    window.UserSession["JwtToken"] = token;
    return token;
  } catch (e) {
    // console.log("Error Occured while creating JWT Token: ", e)
    return e;
  }
}

async function generateSessionToken(tokenString, iSUat) {
  try {
    var headers = new Headers();
    headers.append("Authorization", `Bearer ${tokenString}`);
    headers.append("Content-Type", "application/json");
    var rawBody = JSON.stringify({ appCode: "BOLTECH" });
    const payloadOption = {
      method: "POST",
      headers: headers,
      body: rawBody,
      credentials: "include",
    };
    const sessionRes = iSUat
      ? await fetch(
          "https://api-dex.icicilife.com/v1/bol/middleware/generate/token",
          payloadOption,
        )
      : await fetch(
          "https://api.icicilife.com/v1/bol/middleware/generate/token",
          payloadOption,
        );
    // const sessionRes = await fetch("https://api.icicilife.com/bol/middleware/generate/token", payloadOption)
    if (sessionRes.status === 200) {
      var sessionData = await sessionRes.json();
      const { status, token } = sessionData;
      // console.log(status)
      window.UserSession["SessionToken"] = token;
      return [token];
    } else {
      // console.log("Invalid response from server")
      return [null];
    }
  } catch (e) {
    console.log("Error Occurred on Generating Session Token: ", e);
    return 0;
  }
}

//Manage Timneout
var startTime = new Date();
var timeoutLength = 1800000;
var startTimeEpoch = startTime.valueOf();
let iSUat = false;
let jwtToken = "";
let sessionToken = "";
let HitOnce = true;
//Check every 30 Mins for Idle
var interval = setInterval(checkTimeout, 1800000);
async function checkTimeout() {
  return;
  var currentTime = new Date();
  var currentTimeEpoch = currentTime.valueOf();
  console.log(
    currentTime,
    currentTimeEpoch,
    startTime,
    startTimeEpoch,
    currentTimeEpoch > startTimeEpoch + timeoutLength,
  );
  if (currentTimeEpoch > startTimeEpoch + timeoutLength) {
    clearInterval(interval);
    console.log("Your current Session is over. Recalling Middleware.");
    //Rehit Session every 30 Mins
    jwtToken = await generateJWTToken(iSUat, true);
    sessionToken = await generateSessionToken(jwtToken, iSUat);
  }
}

async function callMiddlewareAPI(
  apiName,
  body,
  iSUat = false,
  custom_headers = { "Content-Type": "application/json" },
  stringifyBody = false,
  method = "POST",
  queryParams = null,
) {
  if (!custom_headers["Content-Type"]) {
    custom_headers["Content-Type"] = "application/json";
  }
  try {
    if (stringifyBody) body = JSON.stringify(body);
    const response = await service({
      apiName: apiName,
      method: method,
      data: body,
      queryParams: queryParams,
      headers: custom_headers || {},
      directResponse: true,
    });
    return response.data || response;
  } catch (e) {
    console.log("Error Occured on Calling API: ", e);
    throw e;
  }
}

window.callMiddlewareAPI = callMiddlewareAPI;
window.isCallMiddlewareApiChanged = true;

const getSHA256Hash = async (input) => {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray
    .map((item) => item.toString(16).padStart(2, "0"))
    .join("");
  return hash;
};
const GenerateQData = (data, URL = "") => {
  var finalQData = BlowFishReact("true", "", data);
  //Append in URL (When you give URL it will redirect to that URL with qdata)
  if (URL) {
    var startWith = URL.includes("?") ? "&" : "?"; // Some Pages URL has Persona In It Causing Duplicate ? in URL.

    var finalURL =
      URL + `${startWith}UID=${window.UserInput.UID}&qdata=` + finalQData;
    window.open(finalURL, "_blank").focus();
  } else {
    return finalQData;
  }
};

const maskDetail = (value) => {
  if (value.includes("@")) {
    const [mail, domain] = value.split("@");
    const visible = mail.slice(-2);
    const masked = "X".repeat(Math.max(0, mail.length - 2));
    return masked + visible + "@" + domain;
  }

  if (value.includes("/")) {
    const parts = value.split("/");
    if (parts.length !== 3) return value;

    const year = parts[2];
    return `XX/XX/${year}`;
  }
  return value.replace(/.(?=.{4})/g, "X");
};

export {
  validateEmail,
  validateName,
  validatePhone,
  GrabToHScroll,
  BlowFishReact,
  CreateReactCookie,
  numDifferentiation,
  removeCommas,
  addCommas,
  downloadFile,
  suitablityUserInput,
  numConvert,
  scrollToClass,
  scrollToId,
  getCookieBoi,
  getReactStorageBoi,
  getStorageBoi,
  AppFormFunctions,
  setStorageBoi,
  isJson,
  capitalize,
  scrollPatch,
  maskData,
  maskEmail,
  maskMobile,
  ToggleCheckboxError,
  HideLandingLoader,
  InjectCustomAppForm,
  ExistingCustomer,
  ExistingCustToaster,
  callMiddlewareAPI,
  getSHA256Hash,
  GenerateQData,
  generateJWTToken,
  generateSessionToken,
  maskDetail,
};
